<template>
  <el-dialog top="10px"
    title="分类管理"
    :visible.sync="isVisible"
    width="600px"
    :close-on-click-modal="false" :close-on-press-escape="false" :fullscreen="false" :append-to-body="true">

    <el-button class="btn" size="medium" @click="createAction">
      <i class="el-icon-plus"></i>
      <span>新增</span>
    </el-button>

    <div style="margin-top: 20px">
      <el-table :data="list" stripe border style="width: 100%">
        <el-table-column prop="title" label="名称" align="center" min-width="180"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="updateAction(scope.row)">修改</el-button>
            <el-button type="text" @click="deleteAction(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <common-cat-input ref="catInput" @refresh="onRefreshCat"></common-cat-input>
  </el-dialog>
</template>


<script>
import CommonCatInput from "./CommonCatInput";
export default {
  name: "commonCat",
  data() {
    const t = this;
    return {
      list: [],
      type: null,
      isVisible: false,
    }
  },
  mounted() {

  },
  created() {
  },
  components: {CommonCatInput},
  methods: {

    init(list_url, delete_url, add_url) {
      this.list_url = list_url;
      this.delete_url = delete_url;
      this.add_url = add_url;
      this.isVisible = true;
      this.queryCatList();
    },

    onRefreshCat(){
      this.queryCatList();
      this.$emit("refresh")
    },

    queryCatList() {
      let t = this;
      this.$post(
        {
          context: t,
          path: t.list_url,
          params: {
          },
          success: function (data) {
            t.list = data.items;
          }
        }
      )
    },

    //创建
    createAction() {
      this.$refs.catInput.initialAdd(this.add_url)
    },

    //修改
    updateAction(item) {
      this.$refs.catInput.initial(item,this.add_url)
    },


    deleteAction(item) {
      console
      let t = this;
      this.$post(
        {
          context: t,
          path: t.delete_url,
          params: {
            item_id: item.itemId
          },
          success: function (data) {
            t.$message.success("删除成功");
            t.queryCatList();
            t.$emit("refresh")
          }
        }
      )
    },
  },
}
</script>
<style scoped>
@import '../assets/global.css';
</style>


